module.exports = __webpack_public_path__ + "img/packages/stb.c5de0c.png";